"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Route = void 0;

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: convert the path to a constructor-time property
//       may need changes on the route-builder w/r/t when
//       the parent route is set and when the route-named
//       properties are set
var Route =
/*#__PURE__*/
function () {
  // still private, but shhh, don't tell anyone
  // _pathBuilder: (...args: any[]) => string;
  function Route() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var subRoutes = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Route);

    _defineProperty(this, "_path", void 0);

    _defineProperty(this, "_subRoutes", void 0);

    _defineProperty(this, "_parent", void 0);

    this._path = path;
    this._subRoutes = subRoutes;
  }

  _createClass(Route, [{
    key: "with",
    value: function _with() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = this.path;
      var tokens = (0, _utils.extractTokens)(path);
      var detectedParams = Object.keys(params);

      if (detectedParams.length !== tokens.length) {
        throw new Error("The wrong number of dynamic segments were passed. Expected to have each of [".concat(tokens.join(', '), "], but was passed [").concat(detectedParams.join(', '), "]"));
      }

      detectedParams.forEach(function (token) {
        var value = params[token];
        path = path.replace(":".concat(token), "".concat(value));
      });
      return path;
    }
  }, {
    key: "path",
    get: function get() {
      var fullPath = "".concat(this._path);

      if (this._parent) {
        var parentPath = this._parent.path; // the root route already has a slash,
        // but we need to ensure there is a trailing slash

        if (!parentPath.endsWith('/')) {
          parentPath += '/';
        }

        fullPath = "".concat(parentPath).concat(this._path);
      } // this happens if the root of the tree has no path
      // and there is also a first-level route with no path


      if (fullPath === '') {
        return '/';
      }

      return fullPath;
    }
  }]);

  return Route;
}();

exports.Route = Route;